<div class="object-browser-selection">
    <span class="selected-elements twc-badge twc-badge-outline-info" *ngIf="showSelectedText()">
        {{selectionService.getNumberSelectedElements()}} {{showSelectedText() | translate}}
        <twc-icon *ngIf="selectionResources.selectedElementsText" (click)="onShowElementsChanged()"
            class="cursor-pointer twc-ml-2 eye-icon" shape="eye-show" [size]="24"
            [ngClass]="{'active-eye': showSelectedElements}"
            twcTooltip="{{selectionResources.selectedElementsText | translate}}">
        </twc-icon>
        <twc-icon *ngIf="selectionResources.clearButtonText" class="cursor-pointer twc-ml-2" shape="close" [size]="24"
            twcTooltip="{{selectionResources.clearButtonText | translate}}" (click)="onClearSelection()">
        </twc-icon>
    </span>

    <button *ngIf="selectionResources.deleteButtonText" text="action button" class="twc-button twc-button-primary"
        (click)="onDelete()">
        {{selectionResources.deleteButtonText | translate}}
    </button>
    <button *ngIf="selectionResources.createProjectText" class="twc-button twc-button-secondary"
        (click)="onCreateProject()">
        {{selectionResources.createProjectText | translate}}
    </button>
</div>